import { connect } from 'react-redux'
import { compose } from 'redux'

import LocalComponent from '../components/Indicator'
import { formatId,updateAnswer} from '../actions'

function mapStateToProps(state, ownProps) {
    const {cpId,dimensionId} = ownProps

    return {
        formattedId: formatId(cpId,dimensionId)
    }
}


const mapDispatchToProps = (dispatch, ownProps) => {
    const {parentId, cpId,dimensionId, store} = ownProps
    return {
        updateAnswer: (e) => { 
            dispatch(updateAnswer(parentId,cpId,dimensionId,e.target.id, store))
        }
    }
}


export default compose(
    connect(
    mapStateToProps,
    mapDispatchToProps)
)(LocalComponent)


// WEBPACK FOOTER //
// ./src/activities/containers/Indicator.js